<div class="sm:hidden mx:block" style="background: white;">
  <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
    border-bottom: 1px solid black;"></customer-select>
</div>
<div class="create-claim">

  <!-- ============ Page header ============ -->
  <div class="page-header">
    <h1 class="page-title">{{ pageTitleKey | translate }}</h1>
  </div>

  <!-- ============ Section: 基本信息 ============ -->
  <section class="section">
    <div class="section-header-row">
      <h2 class="section-title">
        <span class="title-bar"></span>
        {{ 'GENERAL_INFO' | translate }}
      </h2>
      <span class="header-ref" *ngIf="isEditMode && editingCustomerReferenceId">
        #{{ editingCustomerReferenceId }}
      </span>
      <span class="status-chip" *ngIf="isEditMode && editingClaimStatus"
        [style.color]="getStatusColor(editingClaimStatus).color"
        [style.background-color]="getStatusColor(editingClaimStatus).bg">
        {{ editingClaimStatusName || getStatusLabel(editingClaimStatus) }}
      </span>
    </div>

    <nz-spin [nzSpinning]="customerDocTypeLoading || metaLoading || detailLoading" [nzTip]="'LOADING' | translate">
      <form class="section-body" [formGroup]="basicForm">
      <!-- Row 1: 参考类型 (radio) -->
      <div class="form-row">
        <div class="radio-group">
          <span class="form-label">{{ 'CART_PROCESS_ORDER' | translate }}：</span>
          <label class="radio-item" *ngFor="let opt of referenceTypeOptions">
            <input type="radio" formControlName="referenceType" [value]="opt.value" />
            <span class="radio-circle"></span>
            <span class="radio-label">{{ opt.labelKey | translate }}</span>
          </label>
        </div>
      </div>

      <!-- Row 2: 索赔原因 / 索赔分类 / 索赔方式 -->
      <div class="form-row form-row--equal three-cols">
        <div class="filter-field dropdown-field">
          <span class="field-label">{{ 'CLAIM_REASON' | translate }}<span class="required-mark">*</span></span>
          <nz-select class="filter-select" formControlName="reason" nzAllowClear
            [nzSuffixIcon]="dropdownIcon" [nzPlaceHolder]="'PLEASE_SELECT' | translate">
            <nz-option *ngFor="let opt of reasonOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
          </nz-select>
        </div>
        <div class="filter-field dropdown-field">
          <span class="field-label">{{ 'CLAIM_CATEGORY' | translate }}<span class="required-mark">*</span></span>
          <nz-select class="filter-select" formControlName="category" nzAllowClear
            [nzSuffixIcon]="dropdownIcon" [nzPlaceHolder]="'PLEASE_SELECT' | translate">
            <nz-option *ngFor="let opt of categoryOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
          </nz-select>
        </div>
        <div class="filter-field dropdown-field">
          <span class="field-label">{{ 'CLAIM_SCHEME' | translate }}<span class="required-mark">*</span></span>
          <nz-select class="filter-select" formControlName="scheme" nzAllowClear
            [nzSuffixIcon]="dropdownIcon" [nzPlaceHolder]="'PLEASE_SELECT' | translate">
            <nz-option *ngFor="let opt of schemeOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
          </nz-select>
        </div>
      </div>

      <!-- Row 3: 是否自行寄回 (only shown when 索赔方式 is Return for Credit / Exchange / Return) -->
      <ng-container *ngIf="showSelfReturnSection">
      <div class="form-row">
        <div class="radio-group radio-group--inline">
          <span class="form-label">{{ 'CLAIM_CREATE_RETURN_METHOD' | translate }}：</span>
          <label class="radio-item" *ngFor="let opt of selfReturnOptions">
            <input type="radio" formControlName="selfReturn" [value]="opt.value" />
            <span class="radio-circle"></span>
            <span class="radio-label">{{ opt.labelKey | translate }}</span>
          </label>
        </div>
      </div>

      <!-- Self-return warehouse notice (shown only when 是否自行寄回 = 是) -->
      <div class="self-return-notice" *ngIf="basicForm.get('selfReturn')?.value === 'yes'">
        <div class="notice-warning">
          <i nz-icon nzType="info-circle" nzTheme="fill" class="notice-icon"></i>
          <span class="notice-warning-text">
            {{ 'CLAIM_CREATE_RETURN_NOTICE' | translate }}
          </span>
        </div>
        <div class="notice-info">
          <span class="notice-info-text">{{ 'CLAIM_CREATE_WAREHOUSE_INFO' | translate }}</span>
          <a class="notice-copy-link" (click)="copyWarehouseInfo()">{{ 'CLAIM_CREATE_ONE_CLICK_COPY' | translate }}</a>
        </div>
      </div>

      <!-- Customer pickup info (shown only when 是否自行寄回 = 否) -->
      <div class="form-row form-row--equal three-cols pickup-row"
        *ngIf="basicForm.get('selfReturn')?.value === 'no'">
        <div class="filter-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CONTACT_PERSON' | translate }}<span class="required-mark">*</span></span>
          <input class="filter-input" nz-input formControlName="customerContact" [placeholder]="'PLEASE_INPUT' | translate" />
        </div>
        <div class="filter-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CONTACT_TEL' | translate }}<span class="required-mark">*</span></span>
          <input class="filter-input" nz-input formControlName="customerPhone" [placeholder]="'PLEASE_INPUT' | translate" />
        </div>
        <div class="filter-field address-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CUSTOMER_ADDRESS' | translate }}<span class="required-mark">*</span></span>
          <input class="filter-input" nz-input formControlName="customerAddress" [placeholder]="'PLEASE_INPUT' | translate" />
        </div>
      </div>
      </ng-container>
      </form>
    </nz-spin>
  </section>

  <!-- ============ Section: 订单信息 / 索赔信息 ============ -->
  <!-- 参考类型 = 寄售(consignment) → 订单信息(/claimOrder/search) -->
  <!-- 参考类型 = 非寄售(normal) → 索赔信息(/claimInvoice/search) -->
  <section class="section">
    <h2 class="section-title">
      <span class="title-bar"></span>
      {{ isInvoiceMode ? ('CLAIM_CREATE_CLAIM_INFO' | translate) : ('CLAIM_CREATE_ORDER_INFO' | translate) }}
    </h2>

    <nz-spin [nzSpinning]="itemsLoading" [nzTip]="'LOADING' | translate">
      <div class="section-body">
      <!-- Order filter row -->
      <form class="form-row order-filter" [formGroup]="orderForm">
        <div class="filter-field history-field">
          <input class="filter-input" nz-input [placeholder]="'CLAIM_DELIVERY_NO' | translate"
            formControlName="deliveryNumber" (focus)="showHistory('deliveryNumber')" />
          <div class="history-popup" *ngIf="activeHistoryField === 'deliveryNumber'">
            <div class="history-popup-header">
              <span class="history-popup-title">{{ 'CLAIM_CREATE_HISTORY_SEARCH' | translate }}</span>
              <i nz-icon nzType="close" nzTheme="outline" class="history-popup-close"
                (click)="hideHistory()"></i>
            </div>
            <div class="history-popup-body">
              <span class="history-tag" *ngFor="let item of currentDeliveryHistory"
                (click)="selectHistoryItem('deliveryNumber', item)">{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="filter-field history-field">
          <input class="filter-input" nz-input [placeholder]="'CLAIM_DETAIL_MATERIAL_NO' | translate" formControlName="materialNumber"
            (focus)="showHistory('materialNumber')" />
          <div class="history-popup" *ngIf="activeHistoryField === 'materialNumber'">
            <div class="history-popup-header">
              <span class="history-popup-title">{{ 'CLAIM_CREATE_HISTORY_SEARCH' | translate }}</span>
              <i nz-icon nzType="close" nzTheme="outline" class="history-popup-close"
                (click)="hideHistory()"></i>
            </div>
            <div class="history-popup-body">
              <span class="history-tag" *ngFor="let item of materialNumberHistory"
                (click)="selectHistoryItem('materialNumber', item)">{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="filter-field">
          <input class="filter-input" nz-input formControlName="orderNumber" [placeholder]="isInvoiceMode ? ('CLAIM_CREATE_INVOICE_NO' | translate) : ('ORDER_NO' | translate)" />
        </div>
        <div class="filter-field date-field">
          <nz-range-picker class="filter-input" formControlName="dnCreateDateRange"
            style="width: 100%" [nzPlaceHolder]="['CLAIM_CREATE_DN_DATE_FROM' | translate, 'CLAIM_CREATE_DN_DATE_TO' | translate]"></nz-range-picker>
        </div>

        <div class="order-filter-actions">
          <button type="button" class="btn btn-outline" (click)="handleClearOrderFilter()">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
            <span>{{ 'CLEAR' | translate }}</span>
          </button>
          <button type="button" class="btn btn-primary" (click)="handleSearchOrder(true)">
            <i nz-icon nzType="search" nzTheme="outline"></i>
            <span>{{ 'SEARCH' | translate }}</span>
          </button>
        </div>
      </form>
      <div class="table-selection-bar">
        <span class="selection-count">{{ 'CLAIM_CREATE_SELECTED_LINES' | translate: { count: selectedCount } }}</span>
        <button type="button" class="btn btn-outline" (click)="handleQuickAdd()">
          <img src="assets/claim/add-button.png" alt="添加" />
          <span>{{ 'ADD' | translate }}</span>
        </button>
      </div>

      <!-- Items table -->
      <div class="table-wrapper">
        <nz-table
          [nzFrontPagination]="false"
          [nzData]="dataSource"
          [nzTotal]="pagination.total"
          [nzPageIndex]="pagination.pageIndex"
          [nzPageSize]="pagination.pageSize"
          [nzShowPagination]="false"
          [nzScroll]="{ x: 'max-content' }"
        >
          <thead>
            <tr>
              <th nzWidth="40px">
                <label class="checkbox">
                  <input type="checkbox" [checked]="allSelected" [indeterminate]="someSelected"
                    (change)="toggleAll($any($event.target).checked)" />
                  <span class="checkbox-box"></span>
                </label>
              </th>
              <th *ngIf="isInvoiceMode" nzWidth="90px">{{ 'CLAIM_CREATE_INVOICE_NO' | translate }}</th>
              <th *ngIf="isInvoiceMode" nzWidth="90px">{{ 'CLAIM_CREATE_INVOICE_ITEM' | translate }}</th>
              <th *ngIf="isInvoiceMode" nzWidth="120px">{{ 'CLAIM_DETAIL_INVOICE_QTY' | translate }}</th>
              <th *ngIf="isInvoiceMode" nzWidth="180px">{{ 'CLAIM_DETAIL_INVOICE_NET_VALUE' | translate }}</th>
              <th *ngIf="!isInvoiceMode" nzWidth="90px">{{ 'CLAIM_DETAIL_ORDER_NO_ITEM' | translate }}</th>
              <!-- <th *ngIf="!isInvoiceMode" nzWidth="90px">订单行号</th> -->
              <th *ngIf="!isInvoiceMode" nzWidth="120px">{{ 'CLAIM_DETAIL_ORDER_QTY' | translate }}</th>
              <th *ngIf="!isInvoiceMode" nzWidth="180px">{{ 'CLAIM_DETAIL_ORDER_NET_VALUE' | translate }}</th>
              <th nzWidth="120px">{{ 'CLAIM_DETAIL_MATERIAL_NO' | translate }}</th>
              <th nzWidth="120px">{{ 'CLAIM_CREATE_AVAILABLE_QTY' | translate }}</th>
              <th *ngIf="isPriceDifferenceMode" nzWidth="140px">{{ 'CLAIM_DETAIL_UNIT_PRICE' | translate }}<span class="required-mark">*</span></th>
              <th nzWidth="130px" style="text-align: center">{{ 'CLAIM_DETAIL_CLAIM_QTY' | translate }}<span class="required-mark">*</span></th>
              <th nzWidth="180px">{{ 'CLAIM_DETAIL_CLAIM_NET_VALUE' | translate }}</th>
              <th nzWidth="90px">{{ 'CLAIM_DELIVERY_NO' | translate }}</th>
              <th nzWidth="100px">{{ 'DN_ITEM_NO' | translate }}</th>
              <!-- <th nzWidth="140px">描述</th>
              <th nzWidth="100px">单价</th>
              <th nzWidth="120px">提单行数量</th>
              <th nzWidth="160px">剩余可索赔数量</th> -->

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dataSource">
              <td>
                <label class="checkbox" [class.checkbox--disabled]="!isRowClaimable(row)">
                  <input type="checkbox" [checked]="row.selected" [disabled]="!isRowClaimable(row)"
                    (change)="toggleRow(row, $any($event.target).checked)" />
                  <span class="checkbox-box"></span>
                </label>
              </td>
              <td *ngIf="isInvoiceMode">{{ row.invoiceNo }}</td>
              <td *ngIf="isInvoiceMode">{{ row.invoiceItemNo }}</td>
              <td *ngIf="isInvoiceMode">{{ row.dnQuantity }}</td>
              <td *ngIf="isInvoiceMode">{{ row.dnTotalValueWithTax }}</td>
              <td *ngIf="!isInvoiceMode">{{ row.orderNo }}/{{ row.orderItemNo }}</td>
              <!-- <td *ngIf="!isInvoiceMode">{{ row.orderItemNo }}</td> -->
              <td *ngIf="!isInvoiceMode">{{ row.orderQuantity }}</td>
              <td *ngIf="!isInvoiceMode">{{ row.orderTotalAmount }}</td>
              <td>{{ row.materialNumber }}</td>
              <td class="qty-cell">{{ row.remainingQty }}</td>
              <td *ngIf="isPriceDifferenceMode">
                <div class="price-difference-wrapper">
                  <span class="currency-label">CNY</span>
                  <input class="qty-input" type="number" [value]="row.priceDifference" min="0"
                    [disabled]="isRowInCart(row)"
                    (input)="handlePriceDifferenceInput(row, $any($event.target).value, $any($event.target))"
                    (blur)="handlePriceDifferenceBlur(row, $any($event.target).value, $any($event.target))" />
                </div>
              </td>
              <td class="qty-cell">
                <claim-quantity-input [(quantity)]="row.claimQty" [moq]="1" [max]="row.remainingQty"
                  [displayText]="!isRowClaimable(row) ? '-' : undefined"
                  [errorTypes]="(!isRowClaimable(row) || isRowInCart(row)) ? ['invalid_error'] : []"
                  (quantityChange)="handleQtyInput(row, $event)"></claim-quantity-input>
              </td>
              <td>{{ row.amount }}</td>
              <td>{{ row.deliveryNumber }}</td>
              <td>{{ row.deliveryLineNumber }}</td>
              <!-- <td>{{ row.description }}</td>
              <td>{{ row.unitPrice }}</td>
              <td>{{ row.deliveryQty }}</td>
              <td>{{ row.remainingQty }}</td> -->

            </tr>
          </tbody>
        </nz-table>
      </div>

        <!-- Pagination footer -->
        <div class="table-pagination">
          <nz-pagination class="claim-pagination" [nzPageIndex]="pagination.pageIndex"
            [nzPageSize]="pagination.pageSize" [nzTotal]="pagination.total"
            (nzPageIndexChange)="pageIndexChange($event)"></nz-pagination>
        </div>
      </div>
    </nz-spin>
  </section>

  <!-- ============ Section: 其他 ============ -->
  <section class="section">
    <div class="section-header">
      <h2 class="section-title">
        <span class="title-bar"></span>
        {{ 'CLAIM_CREATE_OTHERS' | translate }}
      </h2>

      <!-- Claim cart icon (Figma node 170:4391) -->
      <a class="cart-button" (click)="toggleCart()" [class.is-active]="cartOpen">
        <img src="assets/claim/cart-list.png" alt="购物车" class="cart-icon" />
        <span class="cart-badge" *ngIf="cartItems.length > 0">{{ cartItems.length }}</span>
      </a>
    </div>

    <form class="section-body" [formGroup]="otherForm">
      <div class="upload-section">
        <span class="upload-label">{{ 'CLAIM_CREATE_UPLOAD_FILE_LABEL' | translate }}<span class="required-mark">*</span></span>
        <div class="upload-row">
          <button type="button" class="btn btn-primary" (click)="handleUpload()"
            [disabled]="attachmentUploading">
            <i nz-icon [nzType]="attachmentUploading ? 'loading' : 'upload'" nzTheme="outline"></i>
            <span>{{ attachmentUploading ? ('CLAIM_CREATE_UPLOADING' | translate) : ('UPLOAD' | translate) }}</span>
          </button>
          <a class="download-link" (click)="handleDownloadGuide()">{{ 'CLAIM_CREATE_DOWNLOAD_GUIDE' | translate }}</a>
          <input type="file" data-role="attachment-input" multiple hidden
            (change)="onAttachmentSelected($event)" />
        </div>
        <div class="upload-hints">
          <span class="hint-item">
            <i nz-icon nzType="info-circle" nzTheme="outline" class="hint-icon"></i>
            {{ 'CLAIM_CREATE_FILE_TYPES' | translate }}
          </span>
          <span class="hint-item">
            <i nz-icon nzType="info-circle" nzTheme="outline" class="hint-icon"></i>
            {{ 'CLAIM_CREATE_FILE_SIZE' | translate }}
          </span>
        </div>
      </div>

      <ul class="attachment-list" *ngIf="attachments.length > 0">
        <li *ngFor="let att of attachments" class="attachment-item">
          <span class="attachment-left">
            <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
            <span class="attachment-name" (click)="downloadAttachment(att)">{{ att.fileName }}</span>
          </span>
          <i nz-icon nzType="delete" nzTheme="outline" class="attachment-remove"
            (click)="removeAttachment(att)"></i>
        </li>
      </ul>

      <div class="remark-row">
        <span class="remark-label">{{ 'CLAIM_CREATE_REMARK' | translate }}：</span>
        <textarea class="remark-textarea" rows="4" formControlName="remark" maxlength="255" [placeholder]="'CLAIM_CREATE_REMARK_PLACEHOLDER' | translate"></textarea>
      </div>
    </form>
  </section>

  <!-- ============ Footer button group (Fixed Bottom Bar) ============ -->
  <div class="footer-bar">
    <div class="footer-actions">
      <button type="button" class="btn btn-primary" (click)="handleSave()"
        [disabled]="submitting || savingDraft">
        <i nz-icon nzType="loading" nzTheme="outline" *ngIf="submitting"></i>
        <span>{{ 'CLAIM_CREATE_SUBMIT' | translate }}</span>
      </button>
      <button type="button" class="btn btn-outline" (click)="handleSaveDraft()"
        [disabled]="submitting || savingDraft">
        <i nz-icon nzType="loading" nzTheme="outline" *ngIf="savingDraft"></i>
        <span>{{ isEditMode ? ('CLAIM_CREATE_UPDATE_DRAFT' | translate) : ('CLAIM_CREATE_SAVE_DRAFT' | translate) }}</span>
      </button>
      <button type="button" class="btn btn-outline" (click)="handleCancel()"
        [disabled]="submitting || savingDraft">
        <span>{{ 'CANCEL' | translate }}</span>
      </button>
    </div>
  </div>

  <ng-template #dropdownIcon>
    <i nz-icon nzType="caret-down" nzTheme="outline" class="dropdown-caret"></i>
  </ng-template>

  <!-- ============ Claim cart popup (Figma node 170:6346) ============ -->
  <div class="cart-popup-overlay" *ngIf="cartOpen" (click)="closeCart()">
    <div class="cart-popup" (click)="$event.stopPropagation()">
      <div class="cart-popup-header">
        <h3 class="cart-popup-title">
          <span class="title-bar"></span>
          {{ 'CLAIM_DETAILS' | translate }}
        </h3>
      </div>

      <div class="cart-popup-body">
          <div class="cart-table-wrapper">
            <nz-table
              *ngIf="cartItems.length > 0; else emptyCart"
              [nzData]="cartItems"
              [nzFrontPagination]="false"
              [nzShowPagination]="false"
              [nzScroll]="{ x: 'max-content' }"
            >
              <thead>
                <tr>
                  <th *ngIf="isInvoiceMode" nzWidth="90px">{{ 'CLAIM_DETAIL_INVOICE_NO_ITEM' | translate }}</th>
                  <!-- <th *ngIf="isInvoiceMode" nzWidth="120px">发票行号</th> -->
                  <th *ngIf="isInvoiceMode" nzWidth="110px">{{ 'CLAIM_DETAIL_INVOICE_QTY' | translate }}</th>
                  <th *ngIf="isInvoiceMode" nzWidth="180px">{{ 'CLAIM_DETAIL_INVOICE_NET_VALUE' | translate }}</th>
                  <th *ngIf="!isInvoiceMode" nzWidth="90px">{{ 'CLAIM_DETAIL_ORDER_NO_ITEM' | translate }}</th>
                  <!-- <th *ngIf="!isInvoiceMode" nzWidth="120px">订单行号</th> -->
                  <th *ngIf="!isInvoiceMode" nzWidth="120px">{{ 'CLAIM_DETAIL_ORDER_QTY' | translate }}</th>
                  <th *ngIf="!isInvoiceMode" nzWidth="210px">{{ 'CLAIM_DETAIL_ORDER_NET_VALUE' | translate }}</th>
                  <th nzWidth="120px">{{ 'CLAIM_DETAIL_MATERIAL_NO' | translate }}</th>
                  <th nzWidth="120px">{{ 'CLAIM_CREATE_AVAILABLE_QTY' | translate }}</th>
                  <th *ngIf="isPriceDifferenceMode" nzWidth="170px">{{ 'CLAIM_DETAIL_UNIT_PRICE' | translate }}<span class="required-mark">*</span></th>
                  <th nzWidth="130px" style="text-align: center">{{ 'CLAIM_DETAIL_CLAIM_QTY' | translate }}<span class="required-mark">*</span></th>
                  <th nzWidth="180px">{{ 'CLAIM_DETAIL_CLAIM_NET_VALUE' | translate }}</th>
                  <th nzWidth="120px">{{ 'CLAIM_DETAIL_DELIVERY_NO_ITEM' | translate }}</th>
                  <!-- <th nzWidth="100px">提单行号</th> -->
                  <th nzWidth="60px" style="text-align: center">{{ 'OPERATIONS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of cartItems; trackBy: trackCartItem">
                  <td *ngIf="isInvoiceMode">{{ item.invoiceNo }}/{{ item.invoiceItemNo }}</td>
                  <!-- <td *ngIf="isInvoiceMode">{{ item.invoiceItemNo }}</td> -->
                  <td *ngIf="isInvoiceMode">{{ item.dnQuantity }}</td>
                  <td *ngIf="isInvoiceMode">{{ item.dnTotalValueWithTax }}</td>
                  <td *ngIf="!isInvoiceMode">{{ item.orderNo }}/{{ item.orderItemNo }}</td>
                  <!-- <td *ngIf="!isInvoiceMode">{{ item.orderItemNo }}</td> -->
                  <td *ngIf="!isInvoiceMode">{{ item.dnQuantity }}</td>
                  <td *ngIf="!isInvoiceMode">{{ item.orderTotalAmount }}</td>
                  <td>{{ item.materialNumber }}</td>
                  <td class="qty-cell">{{ item.submittableQty }}</td>
                  <td *ngIf="isPriceDifferenceMode">
                    <div class="price-difference-wrapper">
                      <span class="currency-label">CNY</span>
                      <input class="qty-input" type="number" [value]="item.priceDifference" min="0"
                        (input)="handleCartPriceDifferenceInput(item, $any($event.target).value, $any($event.target))"
                        (blur)="handleCartPriceDifferenceBlur(item, $any($event.target).value, $any($event.target))" />
                    </div>
                  </td>
                  <td class="qty-cell">
                    <claim-quantity-input
                      [quantity]="item.claimQty"
                      [syncFromParent]="false"
                      [liveUpdate]="true"
                      [moq]="1"
                      [max]="item.submittableQty"
                      [displayText]="!isCartItemClaimable(item) ? '-' : undefined"
                      [errorTypes]="!isCartItemClaimable(item) ? ['invalid_error'] : []"
                      (quantityChange)="handleCartQtyInput(item, $event)"
                      (quantityBlur)="handleCartQtyInput(item, $event)"></claim-quantity-input>
                  </td>
                  <td class="amount-cell">{{ item.claimAmount }}</td>
                  <td>{{ item.deliveryNumber }}/{{ item.deliveryLineNumber }}</td>
                  <!-- <td>{{ item.deliveryLineNumber }}</td> -->
                  <td class="action-cell">
                    <img src="assets/claim/delete-icon.png" alt="删除" class="cart-delete"
                      (click)="removeCartItem(item)" />
                  </td>
                </tr>
              </tbody>
            </nz-table>
            <ng-template #emptyCart>
              <div class="cart-empty">{{ 'CLAIM_CREATE_EMPTY' | translate }}</div>
            </ng-template>
          </div>
      </div>
      <div class="cart-popup-footer">
        <button type="button" class="btn btn-outline" (click)="handleClearCart()">
          <span>{{ 'CLAIM_CREATE_ONE_CLICK_DELETE' | translate }}</span>
        </button>
        <button type="button" class="btn btn-primary" (click)="saveCartChanges()">
          <span>{{ 'CONFIRM' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
